<template>
  <ValidationObserver ref="validator" slim v-slot="{ handleSubmit }">
    <!-- The modal close button emits differently whether slots were found or not -->
    <div class="lib__dialogs lib__dialogs--open lib__dialogs lib__dialogs--small" data-id="dialogs">
      <div class="lib__dialogs__box">
        <button @click.stop.prevent="cancel" class="lib__dialogs__close">
          <i class="fas fa-times"></i>
          {{ $t('common.close') }}
        </button>
        <div class="lib__dialogs__content">
          <div class="row">
            <div class="col-xs-12">
              <div class="lib__text-center">
                <h2 class="lib__h2" v-if="periodStartDate">
                  {{ $t('dayOfWeek')[calendarService.daysOfWeek[periodStartDate.getDay()]] }}
                  {{ dateService.displayDateText(periodStartDate) }}
                </h2>
                <h3 class="lib__h3">{{ $t('appointment.timeslots.title') }}</h3>
              </div>
            </div>
          </div>
          <!-- API errors -->
          <api-errors />
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="lib__text-center">
                <AppointmentTimeSlots :currentSlots="slotsToDisplay" required v-model="selectedSlot" :loadingSlots="loadingSlots" @input="onSlotSelect" v-if="hasSlots || loadingSlots" />
              </div>
              <div class="lib__dialogs__footer">
                <nav class="lib__btns-nav-list">
                  <a @click.prevent="handleSubmit(selectTimeSlot)" class="lib__btn lib__btn--primary lib__btn--rounded" :class="{ 'lib__btn--disabled': loadingSlots }" href="#">
                    <span>{{ $t('appointment.timeslots.buttons.confirm') }}</span>
                    <i class="fas fa-check"></i>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Emit, Vue, Prop, Watch } from 'vue-property-decorator'
import ApiErrors from '@/components/display/ApiErrors.vue'
import { appointmentService, dateService, calendarService } from '@/services'
import {
  AppointmentSlot
} from '@/models'
import AppointmentTimeSlots from '@/components/inputs/Appointment/AppointmentTimeSlots.vue'
import moment from 'moment'

@Component({ components: { ApiErrors, AppointmentTimeSlots } })
export default class AppointmentTimeslotSelection extends Vue {
  //#region [Props]
  @Prop({ type: Array, required: false }) public currentSlots!: AppointmentSlot[] | null

  //#endregion

  //#region [Data]
  public dateService = dateService
  public calendarService = calendarService

  private loadingSlots: boolean = false
  private selectedSlot: AppointmentSlot | null = null

  //#endregion

  //#region [Computed]
  private get hasSlots(): boolean {
    return !!this.currentSlots && this.currentSlots.length > 0
  }

  private get periodStartDate() : Date | null {
    return this.currentSlots?.length ? this.currentSlots[0].startDate : null
  }

  //#endregion

  //#region [Methods]
  private get slotsToDisplay(): AppointmentSlot[] {
    
    if(!this.currentSlots)
      return [];

    return this.currentSlots.map<AppointmentSlot>((a, index) => {
      a.key = moment(a.startDate).format("YYYY-MM-DD") + "-" + index
      a.timeslotLabel = appointmentService.timeslotLabel(a, false)
      return a
    })
  }

  private onSlotSelect(value: AppointmentSlot) {
    this.selectedSlot = value
  }

  //#endregion
  
  //#region [Emit]
  @Emit('input')
  private selectTimeSlot(): AppointmentSlot {
    
    return {
      endDate: this.selectedSlot!.endDate,
      otherDate: this.selectedSlot!.otherDate,
      startDate: this.selectedSlot!.startDate,
      timeslotLabel: this.selectedSlot!.timeslotLabel,
      key: this.selectedSlot!.key.substring(0,this.selectedSlot?.key.lastIndexOf('-'))
    } 
  }

  @Emit('cancel')
  private cancel(): boolean {
    return true
  }
  //#endregion
}
</script>
